module.exports = __webpack_public_path__ + "3d3a106bb8f1a783f954256158984d46.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MR.svg
// module id = JorU
// module chunks = 0